module.exports = __webpack_public_path__ + "img/isms.3d60123.png";